import styled from 'styled-components/native'

export const IconTileContainer = styled.View`
  margin: 5px;
  width: 160px;
`

export const IconTileIconContainer = styled.View<{ highlightcolor: string }>`
  border-radius: 5px;
  width: 160px;
  height: 160px;
  background-color: ${({ highlightcolor }) => highlightcolor}15;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IconTileText = styled.Text`
  color: white;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(1, 1, 1, 0.2);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0.8em 0.5em 0.5em;
`
